import Objdict from "objdict"
import Unit from "@frog/source/models/Unit.js"
import Stage from "@frog/source/models/Stage.js"
import {nanoid} from "nanoid"

export default class Delta {
    static copyDeltastageSum(oldSum) {
        const newSum = {}
        oldSum = oldSum || {}
        Object.keys(oldSum).forEach((key) => {
            if(key == "dialogue") {
                newSum.dialogue = Object.assign({}, oldSum.dialogue)
                return
            }
            if(key == "flags") {
                newSum.flags = Object.assign({}, oldSum.flags)
                return
            }
            if(key == "player") {
                newSum.player = {}
                newSum.player.score = oldSum.player.score
                newSum.player.affiliation = oldSum.player.affiliation
                newSum.player.inventory = Object.assign({}, oldSum.player.inventory)
                return
            }
            if(key == "units") {
                newSum.units = {}
                Object.keys(oldSum.units).forEach((unitKey) => {
                    newSum.units[unitKey] = {}
                    Object.keys(oldSum.units[unitKey]).forEach((key) => {
                        if(key == "energy" || key == "inventory") {
                            newSum.units[unitKey][key] = {}
                            Object.keys(oldSum.units[unitKey][key]).forEach((subkey) => {
                                newSum.units[unitKey][key][subkey] = Object.assign({}, oldSum.units[unitKey][key][subkey])
                            })
                        } else if(key == "effects" || key == "position") {
                            newSum.units[unitKey][key] = Object.assign({}, oldSum.units[unitKey][key])
                        } else {
                            newSum.units[unitKey][key] = oldSum.units[unitKey][key]
                        }
                    })
                })
                return
            }
            newSum[key] = oldSum[key]
        })
        return newSum
    }
    static sumDeltastages(oldSum, newDeltas, stage) {
        let newSum = this.copyDeltastageSum(oldSum)

        if(newDeltas instanceof Array == false) {
            newDeltas = [newDeltas]
        }
        newDeltas.forEach((newDelta) => {
            if(newDelta == undefined) return
            Object.keys(newDelta).forEach((key) => {
                if(newDelta[key] instanceof Function) return
                if(key == "mark" || key == "motion" || key == "timing" || key == "func" || key == "audiomix") return
                if(key == "deltastages") {
                    newDelta.deltastages.forEach((subnewDelta) => {
                        newSum = this.sumDeltastages(newSum, subnewDelta, stage)
                    })
                    return
                }
                if(key == "position" || key == "key") {
                    // console.log("trying to enter unit property as delta", newDeltas, newDelta)
                    return
                }
                if(key == "flag" || key == "flags") {
                    let flags = newDelta.flags || {}
                    if(newDelta.flag != undefined) {
                        flags[newDelta.flag.key] = newDelta.flag.value
                    }
                    newSum.flags = Objdict.merge(oldSum.flags || {}, flags)
                    return
                }
                if(key == "player") {
                    newSum.player = newDelta.player
                    newSum.player.inventory = Objdict.merge(oldSum.player.inventory || {}, newDelta.player.inventory)
                    return
                }
                // if it's not one of the above merges, nor a deltaunit
                // then it's an absolute set and we're safe to nuke the old values
                if(key != "units" && key != "unit" && key != "stage") {
                    newSum[key] = newDelta[key]
                    return
                }

                oldSum.units = oldSum.units || {}
                newSum.units = oldSum.units
                let newDeltaunits
                let isAbsolute = false
                if(key == "units") {
                    newDeltaunits = newDelta.units
                } else if(key == "stage") {
                    newDeltaunits = newDelta.stage.units
                    isAbsolute = true
                } else if(key == "unit") {
                    newDeltaunits = {}
                    newDeltaunits[newDelta.unit.key] = newDelta.unit
                    isAbsolute = true
                }

                Objdict.forEach(newDeltaunits, (deltaunit, unitKey) => {
                    if(deltaunit == undefined) {
                        newSum.units[unitKey] = undefined
                        return
                    }
                    const oldSumDeltaunit = oldSum.units[unitKey] || {}
                    newSum.units[unitKey] = newSum.units[unitKey] || {}
                    const newSumDeltaunit = newSum.units[unitKey]
                    //newSum.units[unitKey] = Objdict.merge(oldSumDeltaunit, deltaunit)
                    Object.keys(deltaunit).forEach((unitPropertyKey) => {
                        if(unitPropertyKey == "energy") {
                            newSumDeltaunit.energy = Objdict.merge(oldSumDeltaunit.energy || {}, deltaunit)
                            return
                        }
                        if(unitPropertyKey == "inventory") {
                            newSumDeltaunit.inventory.count = oldSumDeltaunit.inventory.count + deltaunit.inventory.count
                            newSumDeltaunit.inventory.items = Objdict.merge(oldSumDeltaunit.inventory.items || {}, deltaunit.inventory.items)
                            return
                        }
                        if(unitPropertyKey == "effects") {
                            newSumDeltaunit.effects = Objdict.merge(oldSumDeltaunit.effects || {}, deltaunit.effects)
                            return
                        }
                        const stagedUnit = stage.units[unitKey]
                        if(isAbsolute == false) {
                            if(unitPropertyKey == "armor") {
                                newSumDeltaunit.armor = (oldSumDeltaunit.armor || stagedUnit.armor) + deltaunit.armor
                                return
                            }
                            if(unitPropertyKey == "health") {
                                newSumDeltaunit.health = (oldSumDeltaunit.health || stagedUnit.health) + deltaunit.health
                                return
                            }
                        }
                        if(unitPropertyKey == "position") {
                            newSumDeltaunit.position = newSumDeltaunit.position || {}
                            newSumDeltaunit.position.mode = "absolute"
                            if(isAbsolute == true
                            || deltaunit.position.mode == "absolute") {
                                if(deltaunit.position.x !== undefined) {
                                    newSumDeltaunit.position.x = deltaunit.position.x
                                }
                                if(deltaunit.position.y !== undefined) {
                                    newSumDeltaunit.position.y = deltaunit.position.y
                                }
                                if(deltaunit.position.z !== undefined) {
                                    newSumDeltaunit.position.z = deltaunit.position.z
                                }
                            } else {
                                const oldPosition = oldSumDeltaunit.position || {}
                                newSumDeltaunit.position.x = (oldPosition.x || stagedUnit.position.x) + (deltaunit.position.x || 0)
                                newSumDeltaunit.position.y = (oldPosition.y || stagedUnit.position.y) + (deltaunit.position.y || 0)
                                newSumDeltaunit.position.z = (oldPosition.z || stagedUnit.position.z) + (deltaunit.position.z || 0)
                            }
                            //console.log("summed position", unitKey, newSumDeltaunit.position)
                            return
                        }
                        newSumDeltaunit[unitPropertyKey] = deltaunit[unitPropertyKey]
                    })
                })
            })
        })
        return newSum
    }
    static editUnit(stage, unit, deltaunit, {isAbsolute} = {}) {
        if(isAbsolute == true) {
            if(deltaunit.health !== undefined) {
                unit.health = deltaunit.health
                unit.health = Math.max(unit.health, 0)
            }
            if(deltaunit.armor !== undefined) {
                unit.armor = deltaunit.armor
                unit.armor = Math.min(unit.armor, unit.maxarmor)
                unit.armor = Math.max(unit.armor, 0)
            }
        } else {
            if(deltaunit.health !== undefined) {
                unit.health += deltaunit.health
                unit.health = Math.max(unit.health, 0)
            }
            if(deltaunit.armor !== undefined) {
                unit.armor += deltaunit.armor
                unit.armor = Math.min(unit.armor, unit.maxhealth)
                unit.armor = Math.max(unit.armor, 0)
            }
        }
        if(deltaunit.attacktype != undefined) {
            unit.attacktype = deltaunit.attacktype
        }
        if(deltaunit.attackrange != undefined) {
            unit.attackrange = deltaunit.attackrange
        }
        if(deltaunit.experience != undefined) {
            unit.experience = deltaunit.experience
        }
        if(deltaunit.maxexperience != undefined) {
            unit.maxexperience = deltaunit.maxexperience
        }
        if(deltaunit.properties != undefined) {
            unit.properties = deltaunit.properties // this fully replaces, no add or remove
        }
        if(deltaunit.element != undefined) {
            unit.element = deltaunit.element
        }
        if(deltaunit.title != undefined) {
            unit.title = deltaunit.title
        }
        if(deltaunit.image != undefined) {
            unit.image = deltaunit.image
        }
        if(deltaunit.sprites != undefined) {
            unit.sprites = deltaunit.sprites
        }
        if(deltaunit.mode != undefined) {
            unit.mode = deltaunit.mode
        }
        if(deltaunit.maxhealth != undefined) {
            unit.maxhealth = deltaunit.maxhealth
        }
        if(deltaunit.moverange != undefined) {
            unit.moverange = deltaunit.moverange
        }
        if(deltaunit.defense != undefined) {
            unit.defense = deltaunit.defense
        }
        if(deltaunit.power != undefined) {
            unit.power = deltaunit.power
        }
        if(deltaunit.level != undefined) {
            unit.level = deltaunit.level
        }
        if(deltaunit.score != undefined) {
            unit.score = deltaunit.score
        }
        if(deltaunit.faceKey != undefined) {
            unit.faceKey = deltaunit.faceKey
        }
        if(deltaunit.bodyKey != undefined) {
            unit.bodyKey = deltaunit.bodyKey
        }
        if(deltaunit.imageKey != undefined) {
            unit.imageKey = deltaunit.imageKey
        }
        if(deltaunit.portraitImageKey != undefined) {
            unit.portraitImageKey = deltaunit.portraitImageKey
        }
        if(deltaunit.decalImageKey != undefined) {
            unit.decalImageKey = deltaunit.decalImageKey
        }
        if(deltaunit.weaponImageKey !== undefined) {
            unit.weaponImageKey = deltaunit.weaponImageKey
        }
        if(deltaunit.direction != undefined) {
            unit.direction = {}
            unit.direction.x = deltaunit.direction.x ?? 0
            unit.direction.y = deltaunit.direction.y ?? 0
        }
        if(deltaunit.state != undefined) {
            unit.state = deltaunit.state
        }
        if(deltaunit.isDead != undefined) {
            unit.isDead = deltaunit.isDead
        }
        if(deltaunit.deathTimer != undefined) {
            unit.deathTimer = deltaunit.deathTimer
        }
        if(deltaunit.hasBeenRemoved !== undefined) {
            unit.hasBeenRemoved = deltaunit.hasBeenRemoved
        }
        if(deltaunit.spriteKey != undefined) {
            unit.spriteKey = deltaunit.spriteKey
        }
        if(deltaunit.position != undefined) {
            if(isAbsolute == true
            || deltaunit.position.mode == "absolute") {
                if(deltaunit.position.x !== undefined) {
                    unit.position.x = deltaunit.position.x
                }
                if(deltaunit.position.y !== undefined) {
                    unit.position.y = deltaunit.position.y
                }
                if(deltaunit.position.z !== undefined) {
                    unit.position.z = deltaunit.position.z
                }
            } else {
                unit.position.x += deltaunit.position.x || 0
                unit.position.y += deltaunit.position.y || 0
                unit.position.z += deltaunit.position.z || 0
            }
            // TODO: RE-CALCULATE TRAP ZONES?? OR CANCEL
            // POSITIONING-BASED EFFECTS LIKE BIND??
        }
        if(deltaunit.energy != undefined) {
            Object.keys(deltaunit.energy).forEach((key) => {
                if(deltaunit.energy[key] != undefined) {
                    unit.energy[key] = deltaunit.energy[key]
                }
            })
        }
        if(deltaunit.effects != undefined) {
            Objdict.forEach(deltaunit.effects, (deltaunit, effectKey) => {
                if(deltaunit == undefined) {
                    delete unit.effects[effectKey]
                } else if(unit.effects[effectKey] == undefined) {
                    unit.effects[effectKey] = deltaunit
                } else {
                    unit.effects[effectKey] = Objdict.merge(unit.effects[effectKey], deltaunit)
                }
            })
        }
        if(deltaunit.inventory != undefined) {
            if(deltaunit.inventory.count != undefined) {
                unit.inventory.count += deltaunit.inventory.count
            }
            if(deltaunit.inventory.items != undefined) {
                Objdict.forEach(deltaunit.inventory.items, (item, key) => {
                    if(item == undefined) {
                        delete unit.inventory.items[key]
                    } else {
                        unit.inventory.items[key] = item
                    }
                })
            }
        }
        if(deltaunit.equippedItem !== undefined) {
            if(deltaunit.equippedItem == null) {
                delete unit.equippedItem
            } else {
                unit.equippedItem = deltaunit.equippedItem
            }
        }
        if(deltaunit.item !== undefined) {
            if(deltaunit.item == null) {
                delete unit.item
            }
            unit.item = deltaunit.item
        }
        if(deltaunit.affiliation != undefined) {
            unit.affiliation = deltaunit.affiliation
        }
        if(deltaunit.nextAffiliation != undefined) {
            unit.nextAffiliation = deltaunit.nextAffiliation
        }
        return unit
    }
    static editStage(stage, deltastages) {
        if(deltastages instanceof Array == false) {
            deltastages = [deltastages]
        }
        stage.deltastageSum = this.sumDeltastages(stage.deltastageSum, deltastages, stage)
        deltastages.forEach((deltastage) => {
            if(deltastage == undefined) {
                return
            }

            // DELTA SCHEMA v2 - now supports just .unit to shortcut .units[unitKey]
            if(deltastage.unit != undefined) {
                deltastage.stage = {"unit": deltastage.unit} // TODO DEPRECATE THIS!!
            }
            if(deltastage.stage != undefined) {
                let deltaunits = deltastage.stage.units
                if(deltaunits == undefined
                && deltastage.stage.unit) {
                    deltaunits = [deltastage.stage.unit]
                }

                Objdict.forEach(deltaunits, (deltaunit, unitKey) => {
                    if(deltaunit == undefined) {
                        delete stage.units[unitKey]
                        return
                    }
                    if(stage.units[deltaunit.key] == undefined) {
                        deltaunit.key = deltaunit.key || nanoid()
                        stage.units[deltaunit.key] = Unit.instantiate({"unit": deltaunit})
                        return
                    }
                    Delta.editUnit(stage, stage.units[deltaunit.key], deltaunit, {"isAbsolute": true})
                })

                return
            }
            if(deltastage.phase !== undefined) {
                stage.phase = deltastage.phase
            }
            if(deltastage.player !== undefined) {
                if(deltastage.player.inventory !== undefined) {
                    if(deltastage.player.inventory.items != undefined) {
                        Objdict.forEach(deltastage.player.inventory.items, (item, key) => {
                            if(item == undefined) {
                                delete stage.player.inventory.items[key]
                            } else {
                                stage.player.inventory.items[key] = item
                            }
                        })
                    }
                }
                // TODO: player.party
                // TODO: player.day?
                if(deltastage.player.score !== undefined) {
                    stage.player.score = deltastage.player.score
                }
                if(deltastage.player.affiliation !== undefined) {
                    stage.player.affiliation = deltastage.player.affiliation
                }
            }
            if(deltastage.camera !== undefined) {
                stage.camera = deltastage.camera
            }
            if(deltastage.dialogue !== undefined) {
                stage.dialogue = stage.dialogue || {}
                stage.dialogue.text = deltastage.dialogue.text
                stage.dialogue.index = deltastage.dialogue.index
                // stage.dialogue.speakingCharacter = deltastage.dialogue.speakingCharacter
                stage.dialogue.type = deltastage.dialogue.type
                stage.dialogue.data = deltastage.dialogue.data
                stage.dialogue.portraitScene = deltastage.dialogue.portraitScene
                // stage.dialogue.tags = deltastage.dialogue.tags

                // stage.dialogue.characters = stage.dialogue.characters || {}
                // stage.dialogue.characters[stage.dialogue.speakingCharacter] = stage.dialogue.characters[stage.dialogue.speakingCharacter] || {}
                // stage.dialogue.characters[stage.dialogue.speakingCharacter].tags = stage.dialogue.characters[stage.dialogue.speakingCharacter].tags || {}
                // Objdict.forEach(deltastage.dialogue.tags, (value, key) => {
                //     if(key == "_") return
                //     stage.dialogue.characters[stage.dialogue.speakingCharacter].tags[key] = value
                // })
            }
            if(deltastage.dialogue === undefined) {
                delete stage.dialogue
            }
            if(deltastage.currentEncounterKey !== undefined) {
                stage.currentEncounterKey = deltastage.currentEncounterKey
            }
            if(deltastage.activeEncounterKeys !== undefined) {
                stage.activeEncounterKeys = deltastage.activeEncounterKeys
            }

            if(deltastage.flag != undefined) {
                stage.flags[deltastage.flag.key] = deltastage.flag.value
            }
            if(deltastage.flags != undefined) {
                stage.flags = Objdict.merge(stage.flags, deltastage.flags)
            }
            // DELTA SCHEMA v1 - a full stage object. only supported relative values.
            if(deltastage.actionMark != undefined) {
                stage.actionMark = deltastage.actionMark
            }
            // if(deltastage.light != undefined) {
            //     stage.light = deltastage.light
            // }
            Objdict.forEach(deltastage.units, (deltaunit, key) => {
                const unit = stage.units[key]
                if(unit == undefined) {
                    if(deltaunit.mode == "create") {
                        stage.units[key] = Unit.instantiate({"unit": deltaunit})
                    }
                    return
                }
                if(deltaunit == undefined) {
                    delete stage.units[key]
                    return
                }
                Delta.editUnit(stage, unit, deltaunit)
            })
            if(deltastage.zone != undefined) {
                stage.zone = deltastage.zone
            }
            if(deltastage.turn != undefined) {
                if(deltastage.turn.number != undefined) {
                    stage.turn.number = deltastage.turn.number
                }
                if(deltastage.turn.phase != undefined) {
                    stage.turn.phase = deltastage.turn.phase
                }
                if(deltastage.turn.affiliation != undefined) {
                    stage.turn.affiliation = deltastage.turn.affiliation
                }
            }
        })
        return stage
    }
}


// // TODO: also shadow the tiles
// action.shadowtiles = clonedeep(action.shadowtiles)
// if(action.results != undefined) {
//     Object.keys(action.results).forEach((key) => {
//         const result = action.results[key]
//         if(key.substring(0, 5) === "tile:") {
//             const tile = action.shadowtiles.find((tile) => tile.key == key.substring(5))
//             if(tile != undefined) {
//                 return
//             }
//             tile.isBurning = result.isBurning
//             return
//         }
//         // else is unit!!
//     })
// }

// // USED TO BE IN THE ATTACK BEAT PERFORMANCE
// if(key.substring(0, 5) == "tile:") {
//     let position = key.substring(5)
//     let tile = model.game.chapter.stage.map.tiles[position]
//     if(tile == undefined) {
//         return
//     }
//     tile.isBurning = result.isBurning || tile.isBurning
//     return
// }
// if(result.effects) {
//     unit.applyEffects(result.effects)
// }
// if(result.hasPerformedAction != undefined) {
//     if(result.hasPerformedAction == false) {
//         unit.hasPerformedMove = false
//         unit.hasPerformedAttack = false
//         unit.hasPerformedAction = false
//     }
// }

// if(key == "performer") {
//     unit = stage.findUnitByKey(action.performer.key)
// } else if(key == "target") {
//     unit = stage.findUnitByKey(action.target.key)
// }
